export const EAccount = {
  EvmCompatibleAccount: `EvmCompatibleAccount`,
  EmailAccount: `EmailAccount`,
  Google: "Google",
  Apple: "Apple",
} as const;

export type EAccount = typeof EAccount[keyof typeof EAccount];
